module.exports = __webpack_public_path__ + "10e58ad919ae943ffe535df6de7aeb91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/fuehrer_inactive.svg
// module id = 18
// module chunks = 0